import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M23.653 42.983a1 1 0 0 0-1.011-.989c-.334.004-.671.006-1.011.006-6.472 0-11.882-.683-16.227-2.04a2 2 0 0 1-1.377-2.237l.844-5.073a5 5 0 0 1 4.5-4.161c3.762-.326 7.849-.489 12.26-.489.352 0 .702.001 1.05.003a1 1 0 0 0 .012-2A186.92 186.92 0 0 0 21.631 26c-4.467 0-8.61.165-12.432.497a7 7 0 0 0-6.3 5.825l-.844 5.073a4 4 0 0 0 2.753 4.474C9.365 43.292 14.97 44 21.63 44c.347 0 .692-.002 1.033-.006a1 1 0 0 0 .989-1.011Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.63 2c-5.523 0-10 4.477-10 10 0 5.524 4.478 10 10 10 5.524 0 10-4.477 10-10 0-5.524-4.476-10-10-10Zm0 18a8 8 0 0 1-8-8 8 8 0 0 1 8-8 8 8 0 0 1 8 8 8 8 0 0 1-8 8Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.63 34h-3c-1.332 0-1.332 2 0 2h3v3c0 1.333 2 1.333 2 0v-3h3c1.334 0 1.334-2 0-2h-3v-3c0-1.333-2-1.333-2 0v3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.63 24c-6.075 0-11 4.924-11 11s4.925 11 11 11c6.077 0 11-4.925 11-11 0-6.076-4.924-11-11-11Zm0 20a9 9 0 0 1-9-9 9 9 0 0 1 9-9 9 9 0 0 1 9 9 9 9 0 0 1-9 9Z",
    fill: "currentColor"
  }));
};

var SvgAddUser = styled(SvgComponent).withConfig({
  displayName: "AddUser__SvgAddUser",
  componentId: "sc-15bym59-0"
})(["", " ", ""], size, color);
export default SvgAddUser;